import ReducerRegistry from 'jitsi/base/redux/ReducerRegistry';
import { UPDATE_CAMERA_ACTIVE_PARTICIPANTS, UPDATE_CAMERA_INACTIVE_PARTICIPANTS, UPDATE_PARTICIPANTS_BY_CAMERA_STATE, } from './actions';
const DEFAULT_STATE = {
    participantsByCameraState: {
        active: [],
        inactive: [],
    },
};
export const STORE_NAME = 'iisight/features/participants';
ReducerRegistry.register(STORE_NAME, (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case UPDATE_PARTICIPANTS_BY_CAMERA_STATE:
            return {
                ...state,
                participantsByCameraState: action.participants,
            };
        case UPDATE_CAMERA_INACTIVE_PARTICIPANTS:
            return {
                ...state,
                participantsByCameraState: {
                    ...state.participantsByCameraState,
                    inactive: action.participants,
                },
            };
        case UPDATE_CAMERA_ACTIVE_PARTICIPANTS:
            return {
                ...state,
                participantsByCameraState: {
                    ...state.participantsByCameraState,
                    active: action.participants,
                },
            };
        default:
            return state;
    }
});
